module.exports = "<svg id=\"8bb2b50c-0674-4338-aced-22c597f12d70\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>difference-office-hours</title><path d=\"M25,27.86l12.39-6a1.43,1.43,0,1,0-1.25-2.56L25.56,24V11.58a1.48,1.48,0,0,0-3,0l0,14.92A1.56,1.56,0,0,0,25,27.86Z\" style=\"fill:#fff\"></path><path d=\"M25,.67A24.33,24.33,0,1,0,49.33,25,24.33,24.33,0,0,0,25,.67Zm0,45.89A21.55,21.55,0,1,1,46.56,25,21.56,21.56,0,0,1,25,46.55Z\" style=\"fill:#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/difference-office-hours.svg
// module id = 533
// module chunks = 1